import { stages } from 'Constants/stages';
import ClabeForm from './components/ClabeForm';
import InstantRefundEfirma from './components/InstantRefundEfirma';
import ReviewForm from './components/ReviewForm';
import RevisionDeclaration from './components/RevisonDeclaration';

export const INITIAL_STEP = 2;

export const sectionsType = [
  {
    id: 2,
    Component: ClabeForm,
    allowStage: stages.RESULT,
  },
  {
    id: 3,
    Component: ReviewForm,
    allowStage: stages.RESULT,
  },
  {
    id: 6,
    Component: InstantRefundEfirma,
    allowStage: stages.SUBMITTED,
  },
  {
    id: 7,
    Component: RevisionDeclaration,
    allowStage: stages.SUBMITTED,
  },
];
